<template>
  <el-row class="addSize-content">
    <el-col>
      <el-form :inline="true" style="margin-left: 20px;">
        <el-form-item label="选择店铺:" v-if="!hideShopSelect">
          <el-select v-model="shopId" placeholder="请选择店铺" clearable>
            <el-option v-for="shop in shopList" :key="shop.id" :label="shop.shortTitle || shop.title" :value="shop.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="尺码模板:">
          <el-select
            v-model="selectedTemplate"
            value-key="templateId"
            placeholder="请选择模板"
            :disabled="!shopId"
            filterable
            @change="handleTemplateChange"
          >
            <el-option 
              v-for="temp in sizeTemplateList" 
              :key="temp.templateId" 
              :label="temp.templateName" 
              :value="temp"
            >
              <el-tag size="mini" type="primary">{{sizeTagListMap[temp.templateSubType]}}</el-tag>
              <span style="float: right">{{ temp.templateName }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-link href="https://fxg.jinritemai.com/ffa/g/size-chart/manage" target="_blank">去维护</el-link>
        </el-form-item>
      </el-form>
    </el-col>
    <!-- 尺码模板明细 -->
    <el-col class="bg-color">
      <el-form :inline="true">
        <el-form-item label="标 题:" label-width="58px">
          <el-input width="200px" type="text" placeholder="请填写尺码标题" v-model="title" maxlength="10" show-word-limit> </el-input>
        </el-form-item>
        <el-form-item label="标题注释:">
          <el-input width="200px" type="text" placeholder="请填写标题注释" v-model="sub_title" maxlength="20" show-word-limit> </el-input>
        </el-form-item>
        <el-form-item v-if="!componentTemplateRule.supportTemplateSubType" label="模板子类型:">
          <el-select
            v-model="templateSubType"
            value-key="value"
            clearable
            placeholder="未使用模板子类型"
          >
            <el-option v-for="temp in supportTemplateSubTypeList" :key="temp.value" :label="temp.label" :value="temp.value"></el-option>
          </el-select>
        </el-form-item>
        <div v-if="!previewTemplateInfo.shopId">
          <el-form-item label="选择规格:">
            <el-checkbox-group v-model="checkList" style="display: inline">
              <el-checkbox v-for="item in template_sub_type" :key="item" :label="item" :disabled="usefulDimensions.includes(item)"> 
                {{ item }}
                <span v-if="isCustomItem(item)" style="color: #f00;">(自定义)</span>
              </el-checkbox>
            </el-checkbox-group>

          </el-form-item>
          <el-form-item :error="errorMsg" style="margin: 6px 10px 30px;">
            <el-checkbox label="" :disabled="isAllowCustom" v-model="customSpec" style="margin-right: 4px"> </el-checkbox>
            <el-input width="100px" v-model="customSpecName" @blur="validateCustomSpecName" type="text" placeholder="自定义规格"></el-input>
          </el-form-item>
        </div>
        <!-- 尺码明细 -->
        <el-table :data="tableList" max-height="300px" class="tableList" :key="colsKey">
          <el-table-column v-for="col in cols" :key="col.prop" v-bind="col.attrs">
            <template slot="header">
              <p>{{ col.attrs.label }}</p>
              <p class="header-ruleTip">{{ col.specRuleTip }}</p>
            </template>
            <template slot-scope="{ row, $index }">
              <template v-if="col.prop != 'opcols'">
                <el-form-item :error="row[col.prop] && row[col.prop].error">
                  <span v-if="isDisabledSizeValue(col, row)" style="font-size: 12px;">{{ row[col.prop].value }}</span>
                  <el-input v-else v-model="row[col.prop].value" placeholder="请输入"></el-input>
                </el-form-item>
              </template>
              <template v-else>
                <el-button type="link" :disabled="$index == 0" @click="handlerPosition('up', $index)">上移</el-button>
                <el-button type="link" :disabled="$index == tableList.length - 1" @click="handlerPosition('down', $index)">下移</el-button>
                <el-button type="link" :disabled="isDisabledSizeValue({prop: '尺码'}, row)" @click="handleDel($index)">删除</el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <!-- 增加行 -->
        <div style="margin-top: 10px;">
            <el-button v-if="!previewTemplateInfo.shopId && checkList.length" type="primary" @click="addRow"> 增加行 </el-button>
            <el-tooltip v-if="shopId && categoryId" content="支持智能填充尺码表中缺失信息。智能填充尺码信息按照发布规则生成，仅供参考" placement="bottom" effect="light">
              <el-button type="primary" @click="generateItemSizeInfo"> 智能填充尺码表 </el-button>
            </el-tooltip>
        </div>
      </el-form>
    </el-col>
    <!-- 另存为模板 -->
    <el-col class="el-form-item__error" v-if="sizeErrorText || sizeSortErrorText">
      <span>  {{ sizeErrorText || sizeSortErrorText }} </span>
    </el-col>
    <el-col class="other-template" v-if="!previewTemplateInfo.shopId">
      <el-checkbox v-model="isShareable">另存为模板</el-checkbox>
      <el-input
        v-show="isShareable"
        width="200px"
        type="text"
        placeholder="请输入模板名称"
        v-model="templateName"
        maxlength="30"
        show-word-limit
      > 
      </el-input>
      <span style="font-size: 12px;padding-left: 20px; color: #999">修改后的尺码仅生效于该商品，若需应用于其他商品，建议另存为模板</span>
    </el-col>
  </el-row>
</template>

<script>
import TableList from '@/components/TableList.vue';

import { queryFxgSizeTemplateList, queryFxgSizeSort, generateFxgSizeInfo } from '@/servers/prod/center/fxg.js';
import { getBytesCount } from "@utils/data"
import { cloneDeep } from 'lodash';

export default {
  props: {
    shopList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    templateList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    previewTemplateInfo:{
      type: Object,
      default: () => {
        return {};
      },
    },
    specifications: {
      type: Array,
      default: () => {
        return [];
      },
    },
    categoryId: {
      type: [Number, String],
      default: '',
    },
    showGenerateBtn: {
      type: Boolean,
      default: false,
    },
    hideShopSelect: {
      type: Boolean,
      default: false,
    },
    componentTemplateRule: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    TableList,
  },
  data() {
    return {
      // 脚长为必填
      template_sub_type_map: {
        clothing: ['身高(cm)', '体重(斤)', '胸围(cm)', '肩宽(cm)', '袖长(cm)', '衣长(cm)', '腰围(cm)', '臀围(cm)'],
        shoe: ['脚长(cm)', '脚宽(cm)', '靴筒高(cm)', '靴筒围(cm)'],
        shoes: ['脚长(cm)', '脚宽(cm)', '靴筒高(cm)', '靴筒围(cm)'],
        undies: ['上胸围(cm)', '胸围差(cm)', '罩杯'],
        children_clothing: ['身高(cm)', '体重(斤)', '年龄/月龄'],
      },
      supportTemplateSubTypeList:[
        {
          label: '服装',
          value: 'clothing'
        },
        {
          label: '内衣',
          value: 'undies'
        },
        {
          label: '鞋靴类',
          value: 'shoes'
        },
        {
          label: '童装',
          value: 'children_clothing'
        },
      ],
      sizeTagListMap:{
        children_clothing:'童装',
        shoes:'鞋靴类',
        undies:'内衣',
        clothing:'服装',
      },
      isSizeMustInput: false,
      sizeDimensionRange: {},
      sizeDimensionRule: {},
      usefulDimensions: [], //  ["身高(cm)", "体重(斤)", "腰围(cm)", "胸围(cm)", "肩宽(cm)", "裙长(cm)"]
      shopId: '',
      selectedTemplate: null,
      templateConfig: {
        templateId: '',
      },
      allSizeTemplateList: [], // 所有尺码模板List
      sizeTemplateList: [], // 尺码模板List
      title: '',
      sub_title: '',
      sizeSortList: [],
      template_sub_type: [],
      checkList: [],
      // cols: [],
      colsKey: 0,
      tableList: [],
      isShareable: false,
      templateName: '',
      customSpec: false,
      customSpecName: '',
      errorMsg: null,
      specialSizeList: [],
      sizeErrorText: '',
      sizeSortErrorText: '', // 尺码排序错误提示
      templateSubType: 'clothing',
      debounceTimers: { validSizeForm: null },
    };
  },
  watch: {
    shopId: {
      handler() {
        this.fetch_fxgSizeTemplateList();
      },
      immediate: true,
    },
    previewTemplateInfo: {
      handler(newVal, oldVal){
        if(!newVal.shopId) return
        this.shopId = this.setDefaultShopId(newVal.shopId)
        this.templateConfig = { ...newVal.templateInfo, templateId: newVal.templateInfo.templateIdStr || newVal.templateInfo.templateId }
        this.initFormData()
      },
      deep: true,
      immediate: true,
    },
    templateList: {
      handler(val) {
        if(this.previewTemplateInfo.shopId) return  // previewTemplateInfo传入时，不处理templateList
        if (val && val.length) {
          const templateConfig = cloneDeep(val[0]);
          this.templateConfig = { ...templateConfig, templateId: templateConfig.templateIdStr || templateConfig.templateId }
          this.shopId = this.setDefaultShopId(this.templateConfig.shopId)
          this.initFormData()
        } else {
          this.clearTemplateConfig(false);
          this.shopId = this.setDefaultShopId(this.shopId)
        }
      },
      immediate: true,
      deep: true,
    },
    customSpec(val) {
      if (val) {
        if (!this.errorMsg) {
          this.template_sub_type.push(this.customSpecName);
          this.checkList.push(this.customSpecName);
          this.customSpec = false;
          this.customSpecName = '';
        }
      }
    },
    checkList: {
      handler(val) {
        // 确保 usefulDimensions 中的规格始终在 checkList 中
        if (this.usefulDimensions.length) {
          const missing = this.usefulDimensions.filter(item => !val.includes(item));
          if (missing.length) {
            this.checkList = [...val, ...missing];
            return;
          }
        }
        val.forEach(key => {
          this.tableList.forEach(obj => {
            if (!(key in obj)) {
              this.$set(obj, key, { value: '', error: null });
            }
          });
        });
      },
      immediate: true
    },
    componentTemplateRule: {
      handler(v) {
        this.sizeDimensionRange = v?.sizeDimensionRange || {};
        this.usefulDimensions = v?.sizeDimensions?.usefulDimensions || []
        this.sizeDimensionRule = v?.sizeDimensionRule || {};
        this.isSizeMustInput = v?.mustInput || false;
        this.templateSubType = v?.supportTemplateSubType || this.templateConfig?.templateSubType || 'clothing';
        // 自动选中 usefulDimensions 中的规格（去重）
        if (this.usefulDimensions.length) {
          const set = new Set([...this.checkList, ...this.usefulDimensions]);
          this.checkList = [...set];
        }
      },
      deep: true,
      immediate: true,
    },
    specifications: {
      handler() {
        this.specialSizeList = [];
        if (this.specifications?.length) {
          this.specifications.forEach(item => {
            if (item.name.includes('尺码') || item.name.includes('鞋码')) {
              item.values.forEach(i => {
                i.value && i.value !== '无规格' && this.specialSizeList.push(i.value.trim());
              });
            }
          });
        }
      },
      immediate: true,
      deep: true,
    },
    tableList: {
      handler() {
        this.sizeSortErrorText = '';
        this.scheduleValidSizeForm();
      },
      deep: true,
      immediate: true,
    },
    templateSubType: {
      handler() {
        // 合并规格类型（模板内置 + 选择）
        const template_map = {};
        let _template_sub_type = Object.keys(this.sizeDimensionRange||{});
        if(!_template_sub_type.length) {
          _template_sub_type = this.template_sub_type_map[this.templateSubType] || [];
        }
        _template_sub_type.forEach(key => { template_map[key] = 1; });
        this.checkList.forEach(item => { if (!template_map[item]) template_map[item] = 1; });
        this.template_sub_type = Object.keys(template_map);
        this.handleSizeTemplateList();
      },
      deep: true,
      immediate: true,
    },
    specialSizeList: {
      handler() {
        this.handleSpecSizeTableItems()
      },
      immediate: true,
    },
    cols() {
      this.colsKey++;
    }
  },
  computed: {
    isAllowCustom() {
      if (!this.customSpecName || this.errorMsg) return true;
      return false;
    },
    cols() {
      if(!this.componentTemplateRule || !this.checkList.length) return [];
      let colsList = this.checkList.map(spec => {
        const specRule = this.sizeDimensionRange[spec];

        let specRuleTip = '';
        if (specRule && specRule.min && specRule.max) {
          specRuleTip = `请填写${specRule.min}-${specRule.max}之间的数值`;
        }
        return {
          prop: spec,
          specRule,
          specRuleTip,
          attrs: {
            label: spec,
            width: '150px',
          },
        };
      });
      colsList = [
        {
          prop: '尺码',
          attrs: { label: '尺码', width: '120px' },
        },
        ...colsList,
      ];
      colsList.push({
        prop: 'opcols',
        attrs: {
          label: '操作',
          'min-width': '180px',
          align: 'center',
          fixed: 'right',
        },
      })
      return colsList;
    },
  },
  // directives: {
  //   loadMore: {
  //     bind(el, binding) {
  //       const selectDom = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
  //       if (!selectDom) return;
  //       selectDom.addEventListener('scroll', function () {
  //         // 判断滚动到底部
  //         const flag = this.scrollHeight - this.scrollTop <= this.clientHeight;
  //         if (flag) {
  //           binding.value();
  //         }
  //       });
  //     },
  //   },
  // },
  methods: {
    isCustomItem(item) {
      let _template_sub_type = Object.keys(this.sizeDimensionRange||{});
      return !_template_sub_type.includes(item)
    },
    setDefaultShopId(shopId) {
      if(this.hideShopSelect) return shopId || this.shopId
      const fallbackId = this.shopList?.[0]?.id || ''
      const exists = !!shopId && this.shopList?.some(item => item.id === shopId)
      const targetId = exists ? shopId : fallbackId
      return targetId
    },
    initFormData() {
      const templateConfig = this.templateConfig || {}
      // if (!templateConfig?.templateId || !this.componentTemplateRule) return;
      if (!this.componentTemplateRule) return;
      const componentData = JSON.parse(templateConfig.componentData || '{}');
      const selected_specs = Array.isArray(componentData.selected_specs) ? componentData.selected_specs : [];
      const config = componentData.config && typeof componentData.config === 'object' ? componentData.config : {};
      const selected_size = Array.isArray(componentData.selected_size) ? componentData.selected_size : [];
      const list = [];
      this.checkList = selected_specs;
      this.title = componentData.title || '';
      this.sub_title = componentData.sub_title || '';
      this.selectedTemplate = templateConfig
      // 构建 tableList，确保每行补齐所有规格字段
      this.$nextTick(() => {
        selected_size.forEach(sizeKey => {
          const cfgRow = config[sizeKey] && typeof config[sizeKey] === 'object' ? config[sizeKey] : {};
          list.push(this.createRow(sizeKey, cfgRow));
        });
        this.tableList = list;
        this.handleSpecSizeTableItems()
      })
    },
    handleSpecSizeTableItems() {
      if (this.isSizeMustInput) { // 尺码表必填
          const currentSizes = new Set((this.tableList || []).map(row => row['尺码'] && row['尺码'].value).filter(Boolean));
          const missingSizes = (this.specialSizeList || []).filter(size => !currentSizes.has(size));
          if(!this.checkList.length && this.specialSizeList.length && !this.usefulDimensions?.length && this.template_sub_type?.length) {
            const defaultChecks = this.template_sub_type.filter(v => ['身高(cm)', '体重(斤)'].includes(v))
            this.checkList = defaultChecks?.length ? defaultChecks : this.template_sub_type.slice(0, 2);
          }
          // 补齐缺失的尺码行
          missingSizes.forEach(size => {
            this.tableList.push(this.createRow(size));
          });
          // 触发校验
          this.scheduleValidSizeForm();
        }
    },
    handleTemplateChange(val) {
      if (!val) {
        this.clearTemplateConfig(false);
        return;
      }
      // 深拷贝，避免直接修改选项对象
      const templateConfig = cloneDeep(val);
      const componentData = JSON.parse(templateConfig.componentData || '{}');
      const selected_specs = Array.isArray(componentData.selected_specs) ? componentData.selected_specs : [];
      let config = componentData.config && typeof componentData.config === 'object' ? componentData.config : {};
      config = Object.keys(config).reduce((acc, key) => {
        acc[key.trim()] = config[key];
        return acc;
      }, {});
      const templateSizes = (componentData.selected_size || []).map(size => size.trim());
      const tableSizes = (this.tableList || []).map(row => row['尺码']?.value).filter(size => size && this.specialSizeList.includes(size) && !templateSizes.includes(size));

      // 并集：模板尺码 ∪ 现有表尺码
      const unionSizes = [...templateSizes, ...tableSizes];
      // 将现有表中的值融合到模板config中，尽量保留已有数据
      unionSizes.forEach(sizeKey => {
        const row = (this.tableList || []).find(r => (r['尺码'] && r['尺码'].value) === sizeKey) || {};
        const cfgRow = config[sizeKey] && typeof config[sizeKey] === 'object' ? config[sizeKey] : {};
        // 确保存在该尺码的配置对象
        if (!config[sizeKey] || typeof config[sizeKey] !== 'object') {
          config[sizeKey] = {};
        }
        // 仅保留当前模板选择的规格字段
        selected_specs.forEach(spec => {
          const existingVal = (row[spec] && row[spec].value) != null ? row[spec].value : undefined;
          if(cfgRow[spec]) {
            config[sizeKey][spec] = cfgRow[spec];
          } else {
            config[sizeKey][spec] = existingVal;
          }
          // if (existingVal != null && existingVal !== '') {
          //   config[sizeKey][spec] = existingVal;
          // } else if (cfgRow[spec] == null) {
          //   // 如果模板原本也没有该规格值，则保持为空
          //   config[sizeKey][spec] = cfgRow[spec];
          // }
        });
      });
      // 写回并集后的数据
      componentData.selected_size = unionSizes;
      componentData.config = config;
      templateConfig.componentData = JSON.stringify(componentData);

      // this.selectedTemplate = val;

      this.templateConfig = templateConfig;
      this.initFormData()
    },
    isDisabledSizeValue(col, row) {
      return this.isSizeMustInput && col.prop === '尺码' && this.specialSizeList.includes(row['尺码'] && row['尺码'].value);
    },
    // 新增：调度校验与列更新，避免频繁触发
    scheduleValidSizeForm() {
      if (this.debounceTimers.validSizeForm) {
        clearTimeout(this.debounceTimers.validSizeForm);
      }
      this.debounceTimers.validSizeForm = setTimeout(() => {
        this.validSizeForm();
      }, 200);
    },
    validSizeForm() {
      if(!this.isSizeMustInput) return;
      let sizeErrorText = '';
      const sizeValues = this.tableList.map(item => item['尺码'].value).filter(Boolean);
      const lackSizeList = this.specialSizeList.filter(size => !sizeValues.includes(size));
      const junmaList = ['均码', 'F', 'XF', 'XXF'];
      const junmaSizes = sizeValues.filter(size => junmaList.includes(size));
      const otherSizes = sizeValues.filter(size => !junmaList.includes(size));
      if (!this.tableList.length) {
        sizeErrorText = `商品尺码表必填！`;
      } else if (lackSizeList.length) {
        sizeErrorText = `尺码模板中缺少尺码 ${lackSizeList} 信息，请补充！`;
      } else if (junmaSizes.length > 0 && otherSizes.length > 0) {
        sizeErrorText = '您的尺码中包含均码，不能同时设置其他尺码，均码包含:均码，F，XF，XXF，请删除其他尺码后再试';
      } else if (!this.templateSubType && this.templateConfig && this.templateConfig.templateId) {
        sizeErrorText = '请填写模版子类型！';
      }
      this.sizeErrorText = sizeErrorText;
      this.validSizeList();
      this.$nextTick(() => {
        this.$emit('validSize');
      });
    },
    async validSizeSort(){
      const sizeSortErrorText = await this.validateValuesBySizeSort();
      this.sizeSortErrorText = sizeSortErrorText;
      return sizeSortErrorText
    },
    validSizeList() {
      if (this.cols.length && this.tableList.length) {
        this.cols.forEach(col => {
          this.tableList.forEach((row,index) => {
            if (row[col.prop]) {
              this.generateRules(row[col.prop], col, row, index);
            }
          });
        });
      }
    },
    validateSizeParameterDuplication(val, col, row, index) {
      const size = row['尺码'].value;
      if (!size) return false;

      const findRow = this.tableList.find((curRow, i) => {
        const curSize = curRow['尺码'].value;
        if (index === i || !curSize) return false;

        // 利用异或逻辑判断性别互斥（即一男一女），兼容“男女/均码”等混合情况
        const isMale = size.includes('男');
        const isFemale = size.includes('女');
        const isCurMale = curSize.includes('男');
        const isCurFemale = curSize.includes('女');

        // 当且仅当性别标识完全相反时跳过（如：男vs女），若存在交集（如：男女vs男）则继续校验
        if (isMale !== isCurMale && isFemale !== isCurFemale) return false;

        return this.isParameterDuplicate(val, curRow[col.prop].value);
      })

      if(findRow){
        return {
          paramName: col.prop,
          size: findRow['尺码'].value,
        }
      }
      return false
    },
  
    // 新增：判断两个参数值是否重复
    isParameterDuplicate(value1, value2) {
      const range1 = this.parseParameterValue(value1);
      const range2 = this.parseParameterValue(value2);
      if (range1.type === 'invalid' || range2.type === 'invalid') return false;
      
      if (range1.type === 'single' && range2.type === 'single') {
        // 单值与单值：相等
        return range1.min === range2.min;
      } else if (range1.type === 'single' && range2.type === 'range') {
        // 单值与范围值：单值在范围值区间范围内（不包括边界）
        return range1.min > range2.min && range1.min < range2.max;
      } else if (range1.type === 'range' && range2.type === 'single') {
        // 范围值与单值：单值在范围值区间范围内（不包括边界）
        return range2.min > range1.min && range2.min < range1.max;
      } 
      // 平台取消了范围值的校验，范围值校验暂注释掉
      // else if (range1.type === 'range' && range2.type === 'range') {
      //   // 范围值与范围值：不允许有重叠，允许边界相接
      //   return !(range1.max <= range2.min || range2.max <= range1.min);
      // }
      
      return false;
    },
    // 新增：解析参数值（单值或范围值）
    parseParameterValue(value) {
      if (!value) return { type: 'invalid', min: 0, max: 0 };
      const v = String(value).trim();
      // 允许多种区间分隔符：- ~ / ～ — －
      const rangeMatch = v.match(/^(\d+(?:\.\d+)?)[-\~\/～—－](\d+(?:\.\d+)?)$/);
      if (rangeMatch) {
        const min = parseFloat(rangeMatch[1]);
        const max = parseFloat(rangeMatch[2]);
        return { type: 'range', min: Math.min(min, max), max: Math.max(min, max) };
      }
      const singleMatch = v.match(/^(\d+(?:\.\d+)?)$/);
      if (singleMatch) {
        const val = parseFloat(singleMatch[1]);
        return { type: 'single', min: val, max: val };
      }
      return { type: 'invalid', min: 0, max: 0 };
    },
    // 根据尺码顺序校验尺码值的大小关系
    async validateValuesBySizeSort() {
      const params = this.tableList.map(row => row['尺码']?.value).filter(Boolean)
      if(params.length === 0) return ''
      const res = await queryFxgSizeSort(params);
      const sizeOrder = res || [];
      
      const sizeOrderMapList = sizeOrder.map(itemList =>
        itemList.reduce((map, { size, sort }) => {
          map[size] = sort
          return map
        }, {})
      )
      for (const sizeOrderMap of sizeOrderMapList) {
        const errorMsg = this.validSingleSizeOrder(sizeOrderMap)
        if (errorMsg) return errorMsg
      }
      return ''
    },
    validSingleSizeOrder(sizeOrderMap) {
      // 过滤出有效的尺码行（排除均码）
      const validRows = this.tableList.filter(row => {
        const sizeValue = row['尺码']?.value;
        return sizeValue && sizeOrderMap[sizeValue] && !['均码', 'F', 'XF', 'XXF'].includes(sizeValue);
      });
      const paramColumns = this.checkList;
       // 按尺码大小排序
      validRows.sort((a, b) => {
        const sizeA = a['尺码']?.value;
        const sizeB = b['尺码']?.value;
        const sortA = sizeOrderMap[sizeA];
        const sortB = sizeOrderMap[sizeB];
        
        // 如果尺码不在预定义列表中，按字符串排序
        if (sortA === undefined && sortB === undefined) {
          return sizeA.localeCompare(sizeB);
        } else if (sortA === undefined) {
          return 1;
        } else if (sortB === undefined) {
          return -1;
        }
        
        return sortA - sortB;
      });
      // 校验每个参数列的大小顺序
      for (let paramName of paramColumns) {
        for (let i = 0; i < validRows.length - 1; i++) {
          const currentRow = validRows[i];
          const nextRow = validRows[i + 1];
          
          const currentValue = currentRow[paramName]?.value;
          const nextValue = nextRow[paramName]?.value;
          
          if (currentValue && nextValue) {
            const currentRange = this.parseParameterValue(currentValue);
            const nextRange = this.parseParameterValue(nextValue);
            
            if (currentRange.type !== 'invalid' && nextRange.type !== 'invalid') {
              const isValidOrder = this.validateParameterOrder(currentRange, nextRange);
              if (!isValidOrder) {
                const currentSize = currentRow['尺码']?.value;
                const nextSize = nextRow['尺码']?.value;
                return `尺码参数大小顺序错误：尺码【${currentSize}】的【${paramName}】参数值应小于尺码【${nextSize}】的参数值`
              }
            }
          }
        }
      }
      
      return null;
    },
  
    // 新增：校验参数顺序是否正确
    validateParameterOrder(range1, range2) {
      if (range1.type === 'single' && range2.type === 'single') {
        // 单值情况：小尺码参数值 < 大尺码参数值
        return range1.min < range2.min;
      // } else if (range1.type === 'range' && range2.type === 'range') {  // 平台取消了范围值的校验，范围值校验暂注释掉
      //   // 范围值情况：小尺码右参数值 <= 大尺码左参数值
      //   return range1.max <= range2.min;
      } else if (range1.type === 'single' && range2.type === 'range') {
        // 单值&范围值混合：小尺码单值 <= 大尺码范围左参数值
        return range1.min <= range2.min;
      // } else if (range1.type === 'range' && range2.type === 'single') {
      //   // 范围值&单值混合：小尺码范围值右参数值 <= 大尺码单值
      //   return range1.max <= range2.min;
      }
      
      return true;
    },
    createRow(size, values = {}) {
      const newRow = { '尺码': { value: (size || '').trim(), error: null } };
      (this.checkList || []).forEach(spec => {
        newRow[spec] = { value: (values[spec] || '').trim(), error: null };
      });
      return newRow;
    },
    // 增加行
    addRow() {
      this.tableList.push(this.createRow());
    },
    handleDel(index) {
      this.tableList.splice(index, 1);
    },
    handlerPosition(type, index) {
      if (type == 'up') {
        this.tableList[index] = this.tableList.splice(index - 1, 1, this.tableList[index])[0];
      } else {
        this.tableList[index] = this.tableList.splice(index + 1, 1, this.tableList[index])[0];
      }
    },
    async generateItemSizeInfo() {
      const sizeTemplate = this.method_getNoValidData()
      const params = {
        shopId: this.shopId,
        categoryId: this.categoryId,
        sizeTemplate
      }
      const curShop = this.shopList.find(shop => shop.id == this.shopId)
      const templateConfig = await generateFxgSizeInfo(params, curShop?.source);
      this.templateConfig = { ...templateConfig, templateId: templateConfig.templateIdStr || templateConfig.templateId }
      this.initFormData()
    },
    // 查询尺码模板列表
    async fetch_fxgSizeTemplateList(otherParams) {
      this.sizeTemplateList = [];
      if (!this.shopId) return;
      const curShop = this.shopList.find(shop => shop.id == this.shopId)
      const res = await queryFxgSizeTemplateList({
        shopId: this.shopId,
        pageNo: 1,
        ...otherParams,
      }, { source: curShop?.source });
      if (!res) return;
      this.allSizeTemplateList = res.records || [];
      this.handleSizeTemplateList();
    },
    handleSizeTemplateList() {
      this.sizeTemplateList = this.allSizeTemplateList.filter(item => item.templateSubType === this.templateSubType);
    },
    // 处理保存数据
    async method_getData() {
      // 仅保留有尺码值的有效行
      const sizeList = (this.tableList || []).filter(row => row?.尺码?.value);
      const colNames = (this.cols || []).map(item => item.prop);
      this.shopId = this.shopId || this.shopList[0]?.id || ''
      
      if(!this.isSizeMustInput && (!this.shopId || !this.checkList?.length || !sizeList?.length)) return {};
      if (!this.shopId) {
        this.$message.error('请选择尺码表店铺');
        return false;
      }
      if(this.isSizeMustInput && !this.checkList?.length) {
        this.$message.error('尺码表必填，请完善！');
        return false;
      }

      // 校验是否存在错误提示
      const hasError = sizeList.some(row => Object.keys(row).some(key => colNames.includes(key) && row[key]?.error));
      if (this.sizeErrorText || hasError) {
        this.$message.error(this.sizeErrorText || '请完善尺码信息！');
        return false;
      }

      // 校验尺码参数顺序
      const sizeSortErrorText = await this.validSizeSort();
      if (sizeSortErrorText) {
        this.$message.error(sizeSortErrorText);
        return false;
      }

      // 去重后的尺码列表
      const selected_size = Array.from(new Set(sizeList.map(item => item.尺码.value))).filter(Boolean);

      // 构建配置：规格 -> 值，统一为字符串或空
      const newConfig = {};
      selected_size.forEach(size => {
        const row = sizeList.find(r => r.尺码.value === size) || {};
        newConfig[size] = {};
        (this.checkList || []).forEach(spec => {
          newConfig[size][spec] = (row[spec]?.value ?? '');
        });
      });

      const componentData = {
        title: this.title || '',
        sub_title: this.sub_title || '',
        selected_specs: Array.isArray(this.checkList) ? this.checkList : [],
        selected_size,
        config: newConfig,
      };

      const _params = {
        componentData: JSON.stringify(componentData),
        shopId: this.shopId,
        templateId: this.isShareable ? '' : (this.templateConfig?.templateId || ''),
        templateName: this.isShareable ? (this.templateName || this.templateConfig?.templateName || '') : (this.templateConfig?.templateName || ''),
        templateType: this.templateConfig?.templateType || 'size_info',
        templateSubType: this.templateSubType,
        shareable: this.isShareable ? true : !!this.templateConfig?.shareable,
        needUpset: true,
      };
      return _params;
    },
    // 处理保存数据
    method_getNoValidData() {
      // 仅保留有尺码值的有效行
      const sizeList = (this.tableList || []).filter(row => row?.尺码?.value);
      const shopId = this.shopId || this.shopList[0]?.id || ''

      // 去重后的尺码列表
      const selected_size = Array.from(new Set(sizeList.map(item => item.尺码.value))).filter(Boolean);

      // 构建配置：规格 -> 值，统一为字符串或空
      const newConfig = {};
      selected_size.forEach(size => {
        const row = sizeList.find(r => r.尺码.value === size) || {};
        newConfig[size] = {};
        (this.checkList || []).forEach(spec => {
          newConfig[size][spec] = (row[spec]?.value ?? '');
        });
      });

      const componentData = {
        title: this.title || '',
        sub_title: this.sub_title || '',
        selected_specs: Array.isArray(this.checkList) ? this.checkList : [],
        selected_size,
        config: newConfig,
      };

      const _params = {
        componentData: JSON.stringify(componentData),
        shopId,
        templateId: this.isShareable ? '' : (this.templateConfig?.templateId || ''),
        templateName: this.isShareable ? (this.templateName || this.templateConfig?.templateName || '') : (this.templateConfig?.templateName || ''),
        templateType: this.templateConfig?.templateType || 'size_info',
        templateSubType: this.templateSubType,
        shareable: this.isShareable ? true : !!this.templateConfig?.shareable,
        needUpset: true,
      };
      return _params;
    },
    clearTemplateConfig(clearShopId = true) {
      if(clearShopId) {
        this.shopId = '';
      }
      this.checkList = [];  
      this.title = '';
      this.sub_title = '';
      this.tableList = [];
      this.customSpec = '';
      this.customSpecName = '';
      this.colsKey = 0;
      this.sizeSortList = [];
      this.sizeErrorText = '';
      this.sizeSortErrorText = '';
      this.errorMsg = null;
      this.templateConfig = {
        templateId: '',
      };
    },
    clearShopId() {
      this.shopId = '';
    },
    // 校验自定义规格只支持最多4个汉字，数字或字母是8个
    validateCustomSpecName(event) {
      let str = event.target.value;
      if (!str) {
        this.errorMsg = null;
        return;
      }
      let count = this.strCode(str);
      if (count > 8) {
        this.errorMsg = '最多输入4个汉字（数字/字母最多8个）';
      } else {
        this.errorMsg = null;
      }
    },
    // 判断字符长度
    strCode(str) {
      let count = 0;
      if (str) {
        let len = str.length;
        for (let i = 0; i < len; i++) {
          if (str.charCodeAt(i) > 225) {
            count += 2;
          } else {
            count++;
          }
        }
        return count;
      }
    },
    // 效验不能为中文字符
    generateRules(propItem, col, row, index) {
      const { prop, specRule } = col;
      const val = propItem.value;

      // 空值校验
      if (!val && val !== 0) {
        propItem.error = '请填写';
        return;
      }

      // 尺码列长度校验
      if (prop === '尺码') {
        propItem.error = getBytesCount(val) > 10 ? '最多输入5个汉字(数字/字母最多10个)' : '';
        return;
      }

      // 罩杯校验（独立于 specRule，使用 sizeDimensionRule）
      if (prop === '罩杯' && this.sizeDimensionRule?.罩杯) {
        propItem.error = this.validateZhaoBei(val, col, row, index);
        return;
      }

      let error = '';
      // 范围/单值校验（有 specRule 配置时才执行）
      if (specRule?.min !== undefined || specRule?.max) {
        const { specRuleTip } = col;
        const isRangeValue = /[-~\/～—－]/.test(val);
        error = isRangeValue
          ? this.validateRangeValue(val, specRule, specRuleTip)
          : this.validateSingleInput(val, specRule, specRuleTip);
      }

      // 参数重复校验（独立于 specRule）
      if (!error && row['尺码']?.value) {
        const duplicateError = this.validateSizeParameterDuplication(val, col, row, index);
        if (duplicateError) {
          error = `与尺码${duplicateError.size}的值有重复`;
        }
      }

      propItem.error = error;
    },
    // 单值校验
    validateSingleInput(val, specRule, specRuleTip) {
      // 检查是否为有效数字
      const numVal = Number(val);
      if (isNaN(numVal)) {
        return specRuleTip || '请输入有效数字';
      }
      // 检查数字是否在范围内
      if (numVal >= specRule.min && numVal <= specRule.max) {
        return '';
      }
      
      return specRuleTip;
    },
    // 区间值校验方法
    validateRangeValue(val, specRule, specRuleTip) {
      // 解析区间值
      const rangeMatch = val.match(/^(\d+(?:\.\d+)?)[-~\/](\d+(?:\.\d+)?)$/);
      if (!rangeMatch) return specRuleTip;
      
      const minValue = parseFloat(rangeMatch[1]);
      const maxValue = parseFloat(rangeMatch[2]);
      if (maxValue <= minValue) return '最大值必须大于最小值'; // 校验1：区间值最大值需要大于最小值
      const minValidate = this.validateSingleInput(minValue, specRule, specRuleTip);
      const maxValidate = this.validateSingleInput(maxValue, specRule, specRuleTip);
      if (minValidate) return minValidate;
      if (maxValidate) return maxValidate;
      return '';
    },
    // 罩杯校验
    validateZhaoBei(val, _col, _row, _index) {
      const rule = this.sizeDimensionRule?.罩杯;
      if (!rule) return '';

      const { splitSymbol = '/', multiValuesMax = 5, letterRangeMin = 'A', letterRangeMax = 'K', numMin = 20, numMax = 120 } = rule;

      // 分割多尺码
      const sizeList = val.split(splitSymbol).map(s => s.trim()).filter(Boolean);

      // 一个输入框最多填写 multiValuesMax 个尺码
      if (sizeList.length > multiValuesMax) {
        return `一个输入框最多填写 ${multiValuesMax} 个尺码`;
      }
      // 必填格式：数字 + 字母 组合（字母不区分大小写）
      const formatReg = /^(\d+)([a-zA-Z]{1,3})$/;

      for (let i = 0; i < sizeList.length; i++) {
        const size = sizeList[i];
        const match = size.match(formatReg);

        if (!match) {
          return `${size} 格式不正确，应为数字+字母组合（如 70A、85C）`;
        }

        const numPart = parseInt(match[1], 10);
        const letterPart = match[2].toUpperCase();

        // 数字部分：最多 3 位
        if (match[1].length > 3) {
          return `${size} 数字部分不能超过 3 位`;
        }
        // 数字范围校验
        if (numPart < numMin || numPart > numMax) {
          return `${size} 数字部分应在 ${numMin}-${numMax} 之间`;
        }
        // 字母部分：最多 3 位
        if (letterPart.length > 3) {
          return `${size} 字母部分不能超过 3 位`;
        }
        // 字母范围校验（A ~ letterRangeMax）
        const minCharCode = letterRangeMin.charCodeAt(0);
        const maxCharCode = letterRangeMax.charCodeAt(0);
        for (let j = 0; j < letterPart.length; j++) {
          const code = letterPart.charCodeAt(j);
          if (code < minCharCode || code > maxCharCode) {
            return `${size} 字母部分超出范围（${letterRangeMin}~${letterRangeMax}）`;
          }
        }
      }
      return '';
    },

  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.addSize-content {
  .tableList {
    ::v-deep th > .cell {
      line-height: 10px;
      height: auto;
      .header-ruleTip {
        color: #bebaba;
      }
    }
    ::v-deep .el-form-item__error {
      position: unset;
    }
  }
  .bg-color {
    background-color: #f9f9fa;
    padding: 10px 20px 20px 20px;
  }
  .other-template {
    margin-top: 10px;
    display: flex;
    align-items: center;
  }
  .el-select-dropdown .el-select-dropdown__item{
    margin-bottom: 4px;
  }
}

</style>
